export const INIT_REQUEST = "INIT_REQUEST";
export const INIT_SUCCESS = "INIT_SUCCESS";
export const INIT_FAILURE = "INIT_FAILURE";
export const INIT_HELP_STATUS = "INIT_HELP_STATUS";

export const INIT_INTERNET_CONNECTION_STATUS = "INIT_INTERNET_CONNECTION_STATUS";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const REFERENCE_CODE_REQUEST = "REFERENCE_CODE_REQUEST";
export const REFERENCE_CODE_SUCCESS = "REFERENCE_CODE_SUCCESS";
export const REFERENCE_CODE_FAILURE = "REFERENCE_CODE_FAILURE";
export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const VERIFY_FAILURE = "VERIFY_FAILURE";
export const FORGET_REQUEST = "FORGET_REQUEST";
export const FORGET_SUCCESS = "FORGET_SUCCESS";
export const FORGET_FAILURE = "FORGET_FAILURE";
export const FORGET_VERIFY_REQUEST = "FORGET_VERIFY_REQUEST";
export const FORGET_VERIFY_SUCCESS = "FORGET_VERIFY_SUCCESS";
export const FORGET_VERIFY_FAILURE = "FORGET_VERIFY_FAILURE";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const PROJECT_USERS_LIST_REQUEST = "PROJECT_USERS_LIST_REQUEST";
export const PROJECT_USERS_LIST_SUCCESS = "PROJECT_USERS_LIST_SUCCESS";
export const PROJECT_USERS_LIST_FAILURE = "PROJECT_USERS_LIST_FAILURE";
export const PROJECT_LIST_REQUEST = "PROJECT_LIST_REQUEST";
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS";
export const PROJECT_LIST_FAILURE = "PROJECT_LIST_FAILURE";
export const PROJECT_STORE_REQUEST = "PROJECT_STORE_REQUEST";
export const PROJECT_STORE_SUCCESS = "PROJECT_STORE_SUCCESS";
export const PROJECT_STORE_FAILURE = "PROJECT_STORE_FAILURE";
export const PROJECT_DELETE_REQUEST = "PROJECT_DELETE_REQUEST";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_DELETE_FAILURE = "PROJECT_DELETE_FAILURE";
export const PROJECT_UPDATE_REQUEST = "PROJECT_UPDATE_REQUEST";
export const PROJECT_UPDATE_SUCCESS = "PROJECT_UPDATE_SUCCESS";
export const PROJECT_UPDATE_FAILURE = "PROJECT_UPDATE_FAILURE";
export const PROJECT_ACCEPT_REQUEST = "PROJECT_ACCEPT_REQUEST";
export const PROJECT_ACCEPT_SUCCESS = "PROJECT_ACCEPT_SUCCESS";
export const PROJECT_ACCEPT_FAILURE = "PROJECT_ACCEPT_FAILURE";
export const PROJECT_REJECT_REQUEST = "PROJECT_REJECT_REQUEST";
export const PROJECT_REJECT_SUCCESS = "PROJECT_REJECT_SUCCESS";
export const PROJECT_REJECT_FAILURE = "PROJECT_REJECT_FAILURE";
export const PROJECT_ARCHIVE_REQUEST = "PROJECT_ARCHIVE_REQUEST";
export const PROJECT_ARCHIVE_SUCCESS = "PROJECT_ARCHIVE_SUCCESS";
export const PROJECT_ARCHIVE_FAILURE = "PROJECT_ARCHIVE_FAILURE";

export const NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST";
export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_FAILURE = "NOTIFICATION_LIST_FAILURE";

export const PROVINCE_REQUEST = "PROVINCE_REQUEST";
export const PROVINCE_SUCCESS = "PROVINCE_SUCCESS";
export const PROVINCE_FAILURE = "PROVINCE_FAILURE";
export const CITY_REQUEST = "CITY_REQUEST";
export const CITY_SUCCESS = "CITY_SUCCESS";
export const CITY_FAILURE = "CITY_FAILURE";
export const CITY_CLEAN_LIST = "CITY_CLEAN_LIST";

export const API_CALL_ACCOUNT_REVIEW_REQUEST =
  "API_CALL_ACCOUNT_REVIEW_REQUEST";
export const API_CALL_SINGLE_ACCOUNT_REVIEW_REQUEST =
  "API_CALL_SINGLE_ACCOUNT_REVIEW_REQUEST";
export const API_STORE_ACCOUNT_REVIEW_REQUEST =
  "API_STORE_ACCOUNT_REVIEW_REQUEST";
export const API_UPDATE_ACCOUNT_REVIEW_REQUEST =
  "API_UPDATE_ACCOUNT_REVIEW_REQUEST";
export const PUT_ACCOUNT_REVIEW = "PUT_ACCOUNT_REVIEW";
export const SELECTED_TAB_ACCOUNT_REVIEW = "SELECTED_TAB_ACCOUNT_REVIEW";

export const API_CALL_ACTIVITY_REQUEST = "API_CALL_ACTIVITY_REQUEST";
export const PUT_ACTIVITY = "PUT_ACTIVITY";
export const API_CALL_ACTIVITY_FAILURE = "API_CALL_ACTIVITY_FAILURE";
export const API_REMOVE_ACTIVITY_REQUEST = "API_REMOVE_ACTIVITY_REQUEST";
export const API_REMOVE_ACTIVITY_SUCCESS = "API_REMOVE_ACTIVITY_SUCCESS";
export const API_REMOVE_ACTIVITY_FAILURE = "API_REMOVE_ACTIVITY_FAILURE";

export const GET_DAILY_ACTIVITY_REQUEST = "GET_DAILY_ACTIVITY_REQUEST";
export const GET_DAILY_ACTIVITY_SUCCESS = "GET_DAILY_ACTIVITY_SUCCESS";
export const GET_DAILY_ACTIVITY_FAILURE = "GET_DAILY_ACTIVITY_FAILURE";

export const GET_MONTHLY_ACTIVITY_REQUEST = "GET_MONTHLY_ACTIVITY_REQUEST";
export const GET_MONTHLY_ACTIVITY_SUCCESS = "GET_MONTHLY_ACTIVITY_SUCCESS";
export const GET_MONTHLY_ACTIVITY_FAILURE = "GET_MONTHLY_ACTIVITY_FAILURE";

export const STORE_ACTIVITY_REQUEST = "STORE_ACTIVITY_REQUEST";
export const STORE_ACTIVITY_SUCCESS = "STORE_ACTIVITY_SUCCESS";
export const STORE_ACTIVITY_FAILURE = "STORE_ACTIVITY_FAILURE";

export const API_REMOVE_PAYMENT_REQUEST = "API_REMOVE_PAYMENT_REQUEST";
export const API_REMOVE_PAYMENT_SUCCESS = "API_REMOVE_PAYMENT_SUCCESS";
export const API_REMOVE_PAYMENT_FAILURE = "API_REMOVE_PAYMENT_FAILURE";

export const GET_ACTIVITY_REQUEST = "GET_ACTIVITY_REQUEST";
export const GET_ACTIVITY_SUCCESS = "GET_ACTIVITY_SUCCESS";
export const GET_ACTIVITY_FAILURE = "GET_ACTIVITY_FAILURE";

export const STORE_PAYMENT_REQUEST = "STORE_PAYMENT_REQUEST";
export const STORE_PAYMENT_SUCCESS = "STORE_PAYMENT_SUCCESS";
export const STORE_PAYMENT_FAILURE = "STORE_PAYMENT_FAILURE";
export const UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST";
export const UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS";
export const UPDATE_PAYMENT_FAILURE = "UPDATE_PAYMENT_FAILURE";
export const GET_PAYMENT_REQUEST = "GET_PAYMENT_REQUEST";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_FAILURE = "GET_PAYMENT_FAILURE";

export const API_REMOVE_RECEIVE_REQUEST = "API_REMOVE_RECEIVE_REQUEST";
export const API_REMOVE_RECEIVE_SUCCESS = "API_REMOVE_RECEIVE_SUCCESS";
export const API_REMOVE_RECEIVE_FAILURE = "API_REMOVE_RECEIVE_FAILURE";
export const GET_RECEIVE_SUBJECT_REQUEST = "GET_RECEIVE_SUBJECT_REQUEST";
export const GET_RECEIVE_SUBJECT_SUCCESS = "GET_RECEIVE_SUBJECT_SUCCESS";
export const GET_RECEIVE_SUBJECT_FAILURE = "GET_RECEIVE_SUBJECT_FAILURE";
export const STORE_RECEIVE_SUBJECT_REQUEST = "STORE_RECEIVE_SUBJECT_REQUEST";
export const STORE_RECEIVE_SUBJECT_SUCCESS = "STORE_RECEIVE_SUBJECT_SUCCESS";
export const STORE_RECEIVE_SUBJECT_FAILURE = "STORE_RECEIVE_SUBJECT_FAILURE";
export const REMOVE_RECEIVE_SUBJECT_REQUEST = "REMOVE_RECEIVE_SUBJECT_REQUEST";
export const REMOVE_RECEIVE_SUBJECT_SUCCESS = "REMOVE_RECEIVE_SUBJECT_SUCCESS";
export const REMOVE_RECEIVE_SUBJECT_FAILURE = "REMOVE_RECEIVE_SUBJECT_FAILURE";
export const UPDATE_RECEIVE_SUBJECT_REQUEST = "UPDATE_RECEIVE_SUBJECT_REQUEST";
export const UPDATE_RECEIVE_SUBJECT_SUCCESS = "UPDATE_RECEIVE_SUBJECT_SUCCESS";
export const UPDATE_RECEIVE_SUBJECT_FAILURE = "UPDATE_RECEIVE_SUBJECT_FAILURE";

export const STORE_RECEIVE_REQUEST = "STORE_RECEIVE_REQUEST";
export const STORE_RECEIVE_SUCCESS = "STORE_RECEIVE_SUCCESS";
export const STORE_RECEIVE_FAILURE = "STORE_RECEIVE_FAILURE";
export const UPDATE_RECEIVE_REQUEST = "UPDATE_RECEIVE_REQUEST";
export const UPDATE_RECEIVE_SUCCESS = "UPDATE_RECEIVE_SUCCESS";
export const UPDATE_RECEIVE_FAILURE = "UPDATE_RECEIVE_FAILURE";
export const GET_RECEIVE_REQUEST = "GET_RECEIVE_REQUEST";
export const GET_RECEIVE_SUCCESS = "GET_RECEIVE_SUCCESS";
export const GET_RECEIVE_FAILURE = "GET_RECEIVE_FAILURE";

export const API_REMOVE_TRANSFER_REQUEST = "API_REMOVE_TRANSFER_REQUEST";
export const API_REMOVE_TRANSFER_SUCCESS = "API_REMOVE_TRANSFER_SUCCESS";
export const API_REMOVE_TRANSFER_FAILURE = "API_REMOVE_TRANSFER_FAILURE";
export const STORE_TRANSFER_REQUEST = "STORE_TRANSFER_REQUEST";
export const STORE_TRANSFER_SUCCESS = "STORE_TRANSFER_SUCCESS";
export const STORE_TRANSFER_FAILURE = "STORE_TRANSFER_FAILURE";
export const GET_TRANSFER_REQUEST = "GET_TRANSFER_REQUEST";
export const GET_TRANSFER_SUCCESS = "GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAILURE = "GET_TRANSFER_FAILURE";
export const UPDATE_TRANSFER_REQUEST = "UPDATE_TRANSFER_REQUEST";
export const UPDATE_TRANSFER_SUCCESS = "UPDATE_TRANSFER_SUCCESS";
export const UPDATE_TRANSFER_FAILURE = "UPDATE_TRANSFER_FAILURE";

export const CONTACT_LIST_REQUEST = "CONTACT_LIST_REQUEST";
export const CONTACT_LIST_SUCCESS = "CONTACT_LIST_SUCCESS";
export const CONTACT_LIST_FAILURE = "CONTACT_LIST_FAILURE";
export const CONTACT_ALL_REQUEST = "CONTACT_ALL_REQUEST";
export const CONTACT_ALL_SUCCESS = "CONTACT_ALL_SUCCESS";
export const CONTACT_ALL_FAILURE = "CONTACT_ALL_FAILURE";
export const CONTACT_SHOW_REQUEST = "CONTACT_SHOW_REQUEST";
export const CONTACT_SHOW_SUCCESS = "CONTACT_SHOW_SUCCESS";
export const CONTACT_SHOW_FAILURE = "CONTACT_SHOW_FAILURE";
export const CONTACT_STORE_REQUEST = "CONTACT_STORE_REQUEST";
export const CONTACT_STORE_SUCCESS = "CONTACT_STORE_SUCCESS";
export const CONTACT_STORE_FAILURE = "CONTACT_STORE_FAILURE";
export const CONTACT_UPDATE_REQUEST = "CONTACT_UPDATE_REQUEST";
export const CONTACT_UPDATE_SUCCESS = "CONTACT_UPDATE_SUCCESS";
export const CONTACT_UPDATE_FAILURE = "CONTACT_UPDATE_FAILURE";
export const CONTACT_ADD_FAVORITE_REQUEST = "CONTACT_ADD_FAVORITE_REQUEST";
export const CONTACT_ADD_FAVORITE_SUCCESS = "CONTACT_ADD_FAVORITE_SUCCESS";
export const CONTACT_ADD_FAVORITE_FAILURE = "CONTACT_ADD_FAVORITE_FAILURE";
export const CONTACT_REMOVE_REQUEST = "CONTACT_REMOVE_REQUEST";
export const CONTACT_REMOVE_SUCCESS = "CONTACT_REMOVE_SUCCESS";
export const CONTACT_REMOVE_FAILURE = "CONTACT_REMOVE_FAILURE";
export const CONTACT_CLEAR_LAST_ITEM = "CONTACT_CLEAR_LAST_ITEM";

export const FUND_LIST_REQUEST = "FUND_LIST_REQUEST";
export const FUND_LIST_SUCCESS = "FUND_LIST_SUCCESS";
export const FUND_LIST_FAILURE = "FUND_LIST_FAILURE";
export const FUND_ALL_REQUEST = "FUND_ALL_REQUEST";
export const FUND_ALL_SUCCESS = "FUND_ALL_SUCCESS";
export const FUND_ALL_FAILURE = "FUND_ALL_FAILURE";
export const FUND_SHOW_REQUEST = "FUND_SHOW_REQUEST";
export const FUND_SHOW_SUCCESS = "FUND_SHOW_SUCCESS";
export const FUND_SHOW_FAILURE = "FUND_SHOW_FAILURE";
export const FUND_STORE_REQUEST = "FUND_STORE_REQUEST";
export const FUND_STORE_SUCCESS = "FUND_STORE_SUCCESS";
export const FUND_STORE_FAILURE = "FUND_STORE_FAILURE";
export const FUND_UPDATE_REQUEST = "FUND_UPDATE_REQUEST";
export const FUND_UPDATE_SUCCESS = "FUND_UPDATE_SUCCESS";
export const FUND_UPDATE_FAILURE = "FUND_UPDATE_FAILURE";
export const FUND_SET_DEFAULT_REQUEST = "FUND_SET_DEFAULT_REQUEST";
export const FUND_SET_DEFAULT_SUCCESS = "FUND_SET_DEFAULT_SUCCESS";
export const FUND_SET_DEFAULT_FAILURE = "FUND_SET_DEFAULT_FAILURE";
export const FUND_REMOVE_REQUEST = "FUND_REMOVE_REQUEST";
export const FUND_REMOVE_SUCCESS = "FUND_REMOVE_SUCCESS";
export const FUND_REMOVE_FAILURE = "FUND_REMOVE_FAILURE";

export const BANK_ACCOUNT_LIST_REQUEST = "BANK_ACCOUNT_LIST_REQUEST";
export const BANK_ACCOUNT_LIST_SUCCESS = "BANK_ACCOUNT_LIST_SUCCESS";
export const BANK_ACCOUNT_LIST_FAILURE = "BANK_ACCOUNT_LIST_FAILURE";
export const BANK_ACCOUNT_ALL_REQUEST = "BANK_ACCOUNT_ALL_REQUEST";
export const BANK_ACCOUNT_ALL_SUCCESS = "BANK_ACCOUNT_ALL_SUCCESS";
export const BANK_ACCOUNT_ALL_FAILURE = "BANK_ACCOUNT_ALL_FAILURE";
export const BANK_ACCOUNT_SHOW_REQUEST = "BANK_ACCOUNT_SHOW_REQUEST";
export const BANK_ACCOUNT_SHOW_SUCCESS = "BANK_ACCOUNT_SHOW_SUCCESS";
export const BANK_ACCOUNT_SHOW_FAILURE = "BANK_ACCOUNT_SHOW_FAILURE";
export const BANK_ACCOUNT_STORE_REQUEST = "BANK_ACCOUNT_STORE_REQUEST";
export const BANK_ACCOUNT_STORE_SUCCESS = "BANK_ACCOUNT_STORE_SUCCESS";
export const BANK_ACCOUNT_STORE_FAILURE = "BANK_ACCOUNT_STORE_FAILURE";
export const BANK_ACCOUNT_UPDATE_REQUEST = "BANK_ACCOUNT_UPDATE_REQUEST";
export const BANK_ACCOUNT_UPDATE_SUCCESS = "BANK_ACCOUNT_UPDATE_SUCCESS";
export const BANK_ACCOUNT_UPDATE_FAILURE = "BANK_ACCOUNT_UPDATE_FAILURE";
export const BANK_ACCOUNT_SET_DEFAULT_REQUEST =
  "BANK_ACCOUNT_SET_DEFAULT_REQUEST";
export const BANK_ACCOUNT_SET_DEFAULT_SUCCESS =
  "BANK_ACCOUNT_SET_DEFAULT_SUCCESS";
export const BANK_ACCOUNT_SET_DEFAULT_FAILURE =
  "BANK_ACCOUNT_SET_DEFAULT_FAILURE";
export const BANK_ACCOUNT_REMOVE_REQUEST = "BANK_ACCOUNT_REMOVE_REQUEST";
export const BANK_ACCOUNT_REMOVE_SUCCESS = "BANK_ACCOUNT_REMOVE_SUCCESS";
export const BANK_ACCOUNT_REMOVE_FAILURE = "BANK_ACCOUNT_REMOVE_FAILURE";

export const API_CALL_BANK_REQUEST = "API_CALL_BANK_REQUEST";
export const PUT_BANK = "PUT_BANK";
export const API_STORE_BANK_REQUEST = "API_STORE_BANK_REQUEST";

export const DEFAULT_CONSTRUCTION_COMPONENT_LIST_REQUEST =
  "DEFAULT_CONSTRUCTION_COMPONENT_LIST_REQUEST";
export const DEFAULT_CONSTRUCTION_COMPONENT_LIST_SUCCESS =
  "DEFAULT_CONSTRUCTION_COMPONENT_LIST_SUCCESS";
export const DEFAULT_CONSTRUCTION_COMPONENT_LIST_FAILURE =
  "DEFAULT_CONSTRUCTION_COMPONENT_LIST_FAILURE";
export const DEFAULT_CONSTRUCTION_COMPONENT_STORE_REQUEST =
  "DEFAULT_CONSTRUCTION_COMPONENT_STORE_REQUEST";
export const DEFAULT_CONSTRUCTION_COMPONENT_STORE_SUCCESS =
  "DEFAULT_CONSTRUCTION_COMPONENT_STORE_SUCCESS";
export const DEFAULT_CONSTRUCTION_COMPONENT_STORE_FAILURE =
  "DEFAULT_CONSTRUCTION_COMPONENT_STORE_FAILURE";

// export const CONSTRUCTION_COMPONENT_LIST_REQUEST =
//   "CONSTRUCTION_COMPONENT_LIST_REQUEST";
// export const CONSTRUCTION_COMPONENT_LIST_SUCCESS =
//   "CONSTRUCTION_COMPONENT_LIST_SUCCESS";
// export const CONSTRUCTION_COMPONENT_LIST_FAILURE =
//   "CONSTRUCTION_COMPONENT_LIST_FAILURE";
export const CONSTRUCTION_COMPONENT_ALL_REQUEST =
  "CONSTRUCTION_COMPONENT_ALL_REQUEST";
export const CONSTRUCTION_COMPONENT_ALL_SUCCESS =
  "CONSTRUCTION_COMPONENT_ALL_SUCCESS";
export const CONSTRUCTION_COMPONENT_ALL_FAILURE =
  "CONSTRUCTION_COMPONENT_ALL_FAILURE";
export const CONSTRUCTION_COMPONENT_SHOW_REQUEST =
  "CONSTRUCTION_COMPONENT_SHOW_REQUEST";
export const CONSTRUCTION_COMPONENT_SHOW_SUCCESS =
  "CONSTRUCTION_COMPONENT_SHOW_SUCCESS";
export const CONSTRUCTION_COMPONENT_SHOW_FAILURE =
  "CONSTRUCTION_COMPONENT_SHOW_FAILURE";
export const CONSTRUCTION_COMPONENT_STORE_REQUEST =
  "CONSTRUCTION_COMPONENT_STORE_REQUEST";
export const CONSTRUCTION_COMPONENT_STORE_SUCCESS =
  "CONSTRUCTION_COMPONENT_STORE_SUCCESS";
export const CONSTRUCTION_COMPONENT_STORE_FAILURE =
  "CONSTRUCTION_COMPONENT_STORE_FAILURE";
export const CONSTRUCTION_COMPONENT_UPDATE_REQUEST =
  "CONSTRUCTION_COMPONENT_UPDATE_REQUEST";
export const CONSTRUCTION_COMPONENT_UPDATE_SUCCESS =
  "CONSTRUCTION_COMPONENT_UPDATE_SUCCESS";
export const CONSTRUCTION_COMPONENT_UPDATE_FAILURE =
  "CONSTRUCTION_COMPONENT_UPDATE_FAILURE";
export const CONSTRUCTION_COMPONENT_ADD_FAVORITE_REQUEST =
  "CONSTRUCTION_COMPONENT_ADD_FAVORITE_REQUEST";
export const CONSTRUCTION_COMPONENT_ADD_FAVORITE_SUCCESS =
  "CONSTRUCTION_COMPONENT_ADD_FAVORITE_SUCCESS";
export const CONSTRUCTION_COMPONENT_ADD_FAVORITE_FAILURE =
  "CONSTRUCTION_COMPONENT_ADD_FAVORITE_FAILURE";
export const CONSTRUCTION_COMPONENT_REMOVE_REQUEST =
  "CONSTRUCTION_COMPONENT_REMOVE_REQUEST";
export const CONSTRUCTION_COMPONENT_REMOVE_SUCCESS =
  "CONSTRUCTION_COMPONENT_REMOVE_SUCCESS";
export const CONSTRUCTION_COMPONENT_REMOVE_FAILURE =
  "CONSTRUCTION_COMPONENT_REMOVE_FAILURE";

export const CONSTRUCTION_COMPONENT_UNITS_LIST_REQUEST =
  "CONSTRUCTION_COMPONENT_UNITS_LIST_REQUEST";
export const CONSTRUCTION_COMPONENT_UNITS_LIST_SUCCESS =
  "CONSTRUCTION_COMPONENT_UNITS_LIST_SUCCESS";
export const CONSTRUCTION_COMPONENT_UNITS_LIST_FAILURE =
  "CONSTRUCTION_COMPONENT_UNITS_LIST_FAILURE";
export const CONSTRUCTION_COMPONENT_UNITS_STORE_REQUEST =
  "CONSTRUCTION_COMPONENT_UNITS_STORE_REQUEST";
export const CONSTRUCTION_COMPONENT_UNITS_STORE_SUCCESS =
  "CONSTRUCTION_COMPONENT_UNITS_STORE_SUCCESS";
export const CONSTRUCTION_COMPONENT_UNITS_STORE_FAILURE =
  "CONSTRUCTION_COMPONENT_UNITS_STORE_FAILURE";

export const DEFAULT_CONSTRUCTION_PHASE_LIST_REQUEST =
  "DEFAULT_CONSTRUCTION_PHASE_LIST_REQUEST";
export const DEFAULT_CONSTRUCTION_PHASE_LIST_SUCCESS =
  "DEFAULT_CONSTRUCTION_PHASE_LIST_SUCCESS";
export const DEFAULT_CONSTRUCTION_PHASE_LIST_FAILURE =
  "DEFAULT_CONSTRUCTION_PHASE_LIST_FAILURE";
export const DEFAULT_CONSTRUCTION_PHASE_STORE_REQUEST =
  "DEFAULT_CONSTRUCTION_PHASE_STORE_REQUEST";
export const DEFAULT_CONSTRUCTION_PHASE_STORE_SUCCESS =
  "DEFAULT_CONSTRUCTION_PHASE_STORE_SUCCESS";
export const DEFAULT_CONSTRUCTION_PHASE_STORE_FAILURE =
  "DEFAULT_CONSTRUCTION_PHASE_STORE_FAILURE";

// export const CONSTRUCTION_PHASE_LIST_REQUEST =
//   "CONSTRUCTION_PHASE_LIST_REQUEST";
// export const CONSTRUCTION_PHASE_LIST_SUCCESS =
//   "CONSTRUCTION_PHASE_LIST_SUCCESS";
// export const CONSTRUCTION_PHASE_LIST_FAILURE =
//   "CONSTRUCTION_PHASE_LIST_FAILURE";
export const CONSTRUCTION_PHASE_ALL_REQUEST = "CONSTRUCTION_PHASE_ALL_REQUEST";
export const CONSTRUCTION_PHASE_ALL_SUCCESS = "CONSTRUCTION_PHASE_ALL_SUCCESS";
export const CONSTRUCTION_PHASE_ALL_FAILURE = "CONSTRUCTION_PHASE_ALL_FAILURE";
export const CONSTRUCTION_PHASE_SHOW_REQUEST =
  "CONSTRUCTION_PHASE_SHOW_REQUEST";
export const CONSTRUCTION_PHASE_SHOW_SUCCESS =
  "CONSTRUCTION_PHASE_SHOW_SUCCESS";
export const CONSTRUCTION_PHASE_SHOW_FAILURE =
  "CONSTRUCTION_PHASE_SHOW_FAILURE";
export const CONSTRUCTION_PHASE_STORE_REQUEST =
  "CONSTRUCTION_PHASE_STORE_REQUEST";
export const CONSTRUCTION_PHASE_STORE_SUCCESS =
  "CONSTRUCTION_PHASE_STORE_SUCCESS";
export const CONSTRUCTION_PHASE_STORE_FAILURE =
  "CONSTRUCTION_PHASE_STORE_FAILURE";
export const CONSTRUCTION_PHASE_UPDATE_REQUEST =
  "CONSTRUCTION_PHASE_UPDATE_REQUEST";
export const CONSTRUCTION_PHASE_UPDATE_SUCCESS =
  "CONSTRUCTION_PHASE_UPDATE_SUCCESS";
export const CONSTRUCTION_PHASE_UPDATE_FAILURE =
  "CONSTRUCTION_PHASE_UPDATE_FAILURE";
export const CONSTRUCTION_PHASE_ADD_FAVORITE_REQUEST =
  "CONSTRUCTION_PHASE_ADD_FAVORITE_REQUEST";
export const CONSTRUCTION_PHASE_ADD_FAVORITE_SUCCESS =
  "CONSTRUCTION_PHASE_ADD_FAVORITE_SUCCESS";
export const CONSTRUCTION_PHASE_ADD_FAVORITE_FAILURE =
  "CONSTRUCTION_PHASE_ADD_FAVORITE_FAILURE";
export const CONSTRUCTION_PHASE_REMOVE_REQUEST =
  "CONSTRUCTION_PHASE_REMOVE_REQUEST";
export const CONSTRUCTION_PHASE_REMOVE_SUCCESS =
  "CONSTRUCTION_PHASE_REMOVE_SUCCESS";
export const CONSTRUCTION_PHASE_REMOVE_FAILURE =
  "CONSTRUCTION_PHASE_REMOVE_FAILURE";

export const TOOLS_LIST_REQUEST = "TOOLS_LIST_REQUEST";
export const TOOLS_LIST_SUCCESS = "TOOLS_LIST_SUCCESS";
export const TOOLS_LIST_FAILURE = "TOOLS_LIST_FAILURE";
export const TOOLS_ALL_REQUEST = "TOOLS_ALL_REQUEST";
export const TOOLS_ALL_SUCCESS = "TOOLS_ALL_SUCCESS";
export const TOOLS_ALL_FAILURE = "TOOLS_ALL_FAILURE";
export const TOOLS_SHOW_REQUEST = "TOOLS_SHOW_REQUEST";
export const TOOLS_SHOW_SUCCESS = "TOOLS_SHOW_SUCCESS";
export const TOOLS_SHOW_FAILURE = "TOOLS_SHOW_FAILURE";
export const TOOLS_STORE_REQUEST = "TOOLS_STORE_REQUEST";
export const TOOLS_STORE_SUCCESS = "TOOLS_STORE_SUCCESS";
export const TOOLS_STORE_FAILURE = "TOOLS_STORE_FAILURE";
export const TOOLS_UPDATE_REQUEST = "TOOLS_UPDATE_REQUEST";
export const TOOLS_UPDATE_SUCCESS = "TOOLS_UPDATE_SUCCESS";
export const TOOLS_UPDATE_FAILURE = "TOOLS_UPDATE_FAILURE";
export const TOOLS_REMOVE_REQUEST = "TOOLS_REMOVE_REQUEST";
export const TOOLS_REMOVE_SUCCESS = "TOOLS_REMOVE_SUCCESS";
export const TOOLS_REMOVE_FAILURE = "TOOLS_REMOVE_FAILURE";

export const GET_CHEQUE_LIST_REQUEST = "GET_CHEQUE_LIST_REQUEST";
export const GET_CHEQUE_LIST_SUCCESS = "GET_CHEQUE_LIST_SUCCESS";
export const GET_CHEQUE_LIST_FAILURE = "GET_CHEQUE_LIST_FAILURE";

export const GET_CALENDAR_DATA_REQUEST = "GET_CALENDAR_DATA_REQUEST";
export const GET_CALENDAR_DATA_SUCCESS = "GET_CALENDAR_DATA_SUCCESS";
export const GET_CALENDAR_DATA_FAILURE = "GET_CALENDAR_DATA_FAILURE";

export const GET_WAGE_RATE_LIST_REQUEST = "GET_WAGE_RATE_LIST_REQUEST";
export const GET_WAGE_RATE_LIST_SUCCESS = "GET_WAGE_RATE_LIST_SUCCESS";
export const GET_WAGE_RATE_LIST_FAILURE = "GET_WAGE_RATE_LIST_FAILURE";
export const WAGE_RATE_LIST_REQUEST = "WAGE_RATE_LIST_REQUEST";
export const WAGE_RATE_LIST_SUCCESS = "WAGE_RATE_LIST_SUCCESS";
export const WAGE_RATE_LIST_FAILURE = "WAGE_RATE_LIST_FAILURE";
export const WAGE_RATE_ALL_REQUEST = "WAGE_RATE_ALL_REQUEST";
export const WAGE_RATE_ALL_SUCCESS = "WAGE_RATE_ALL_SUCCESS";
export const WAGE_RATE_ALL_FAILURE = "WAGE_RATE_ALL_FAILURE";
export const WAGE_RATE_STORE_REQUEST = "WAGE_RATE_STORE_REQUEST";
export const WAGE_RATE_STORE_SUCCESS = "WAGE_RATE_STORE_SUCCESS";
export const WAGE_RATE_STORE_FAILURE = "WAGE_RATE_STORE_FAILURE";
export const WAGE_RATE_NEW_UPDATE_REQUEST = "WAGE_RATE_NEW_UPDATE_REQUEST";
export const WAGE_RATE_NEW_UPDATE_SUCCESS = "WAGE_RATE_NEW_UPDATE_SUCCESS";
export const WAGE_RATE_NEW_UPDATE_FAILURE = "WAGE_RATE_NEW_UPDATE_FAILURE";
export const WAGE_RATE_REMOVE_REQUEST = "WAGE_RATE_REMOVE_REQUEST";
export const WAGE_RATE_REMOVE_SUCCESS = "WAGE_RATE_REMOVE_SUCCESS";
export const WAGE_RATE_REMOVE_FAILURE = "WAGE_RATE_REMOVE_FAILURE";

export const WAGE_RATE_DELETE_REQUEST = "WAGE_RATE_DELETE_REQUEST";
export const WAGE_RATE_DELETE_SUCCESS = "WAGE_RATE_DELETE_SUCCESS";
export const WAGE_RATE_DELETE_FAILURE = "WAGE_RATE_DELETE_FAILURE";

export const WAGE_RATE_UPDATE_REQUEST = "WAGE_RATE_UPDATE_REQUEST";
export const WAGE_RATE_UPDATE_SUCCESS = "WAGE_RATE_UPDATE_SUCCESS";
export const WAGE_RATE_UPDATE_FAILURE = "WAGE_RATE_UPDATE_FAILURE";

export const WAGE_RATE_CREATE_REQUEST = "WAGE_RATE_CREATE_REQUEST";
export const WAGE_RATE_CREATE_SUCCESS = "WAGE_RATE_CREATE_SUCCESS";
export const WAGE_RATE_CREATE_FAILURE = "WAGE_RATE_CREATE_FAILURE";

export const EVENT_LIST_REQUEST = "EVENT_LIST_REQUEST";
export const EVENT_LIST_SUCCESS = "EVENT_LIST_SUCCESS";
export const EVENT_LIST_FAILURE = "EVENT_LIST_FAILURE";

export const DASHBOARD_LIST_REQUEST = "DASHBOARD_LIST_REQUEST";
export const DASHBOARD_LIST_SUCCESS = "DASHBOARD_LIST_SUCCESS";
export const DASHBOARD_LIST_FAILURE = "DASHBOARD_LIST_FAILURE";

export const GET_IMAGE_REQUEST = "GET_IMAGE_REQUEST";
export const GET_IMAGE_SUCCESS = "GET_IMAGE_SUCCESS";
export const GET_IMAGE_FAILURE = "GET_IMAGE_FAILURE";

export const API_CALL_OVERALL_COST_REQUEST = "API_CALL_OVERALL_COST_REQUEST";
export const PUT_OVERALL_COST = "PUT_OVERALL_COST";

export const API_CALL_OVERALL_COST_DETAIL_REQUEST =
  "API_CALL_OVERALL_COST_DETAIL_REQUEST";
export const PUT_OVERALL_COST_DETAIL = "PUT_OVERALL_COST_DETAIL";
export const API_REMOVE_OVERALL_COST_DETAIL_REQUEST =
  "API_REMOVE_OVERALL_COST_DETAIL_REQUEST";
export const API_REMOVE_OVERALL_COST_DETAIL_SUCCESS =
  "API_REMOVE_OVERALL_COST_DETAIL_SUCCESS";
export const API_REMOVE_OVERALL_COST_DETAIL_FAILURE =
  "API_REMOVE_OVERALL_COST_DETAIL_FAILURE";

export const API_CALL_CHEQUE_REVIEW_REQUEST = "API_CALL_CHEQUE_REVIEW_REQUEST";
export const PUT_CHEQUE_REVIEW = "PUT_CHEQUE_REVIEW";
export const API_REMOVE_CHEQUE_REVIEW_REQUEST =
  "API_REMOVE_CHEQUE_REVIEW_REQUEST";
export const API_REMOVE_CHEQUE_REVIEW_SUCCESS =
  "API_REMOVE_CHEQUE_REVIEW_SUCCESS";
export const API_REMOVE_CHEQUE_REVIEW_FAILURE =
  "API_REMOVE_CHEQUE_REVIEW_FAILURE";
export const CHANGE_CHEQUE_STATUE_REQUEST = "CHANGE_CHEQUE_STATUE_REQUEST";
export const CHANGE_CHEQUE_STATUE_SUCCESS = "CHANGE_CHEQUE_STATUE_SUCCESS";
export const CHANGE_CHEQUE_STATUE_FAILURE = "CHANGE_CHEQUE_STATUE_FAILURE";

export const CHANGE_CHEQUE_SOURCE_ID = "CHANGE_CHEQUE_SOURCE_ID";
export const CHANGE_CHEQUE_SOURCE_TYPE = "CHANGE_CHEQUE_SOURCE_TYPE";
export const CHANGE_CHEQUE_SOURCE_INFO = "CHANGE_CHEQUE_SOURCE_INFO";

export const INVITATION_ACCEPT_REQUEST = "INVITATION_ACCEPT_REQUEST";
export const INVITATION_ACCEPT_SUCCESS = "INVITATION_ACCEPT_SUCCESS";
export const INVITATION_ACCEPT_FAILURE = "INVITATION_ACCEPT_FAILURE";

export const INVITATION_REJECT_REQUEST = "INVITATION_REJECT_REQUEST";
export const INVITATION_REJECT_SUCCESS = "INVITATION_REJECT_SUCCESS";
export const INVITATION_REJECT_FAILURE = "INVITATION_REJECT_FAILURE";

export const NOTIFICATION_READ_REQUEST = "NOTIFICATION_READ_REQUEST";

export const GET_COST_AND_PROFIT_REQUEST = "GET_COST_AND_PROFIT_REQUEST";
export const GET_COST_AND_PROFIT_SUCCESS = "GET_COST_AND_PROFIT_SUCCESS";
export const GET_COST_AND_PROFIT_FAILURE = "GET_COST_AND_PROFIT_FAILURE";

export const GET_BALANCE_SHEET_REQUEST_FILE = "GET_BALANCE_SHEET_REQUEST_FILE";
export const GET_BALANCE_SHEET_REQUEST = "GET_BALANCE_SHEET_REQUEST";
export const GET_BALANCE_SHEET_SUCCESS = "GET_BALANCE_SHEET_SUCCESS";
export const GET_BALANCE_SHEET_FAILURE = "GET_BALANCE_SHEET_FAILURE";
export const PROJECT_SETTING_STORE_REQUEST = "PROJECT_SETTING_STORE_REQUEST";
export const PROJECT_SETTING_STORE_SUCCESS = "PROJECT_SETTING_STORE_SUCCESS";
export const PROJECT_SETTING_STORE_FAILURE = "PROJECT_SETTING_STORE_FAILURE";
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_REQUEST =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_REQUEST";
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_SUCCESS =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_SUCCESS";
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_FAILURE =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_FAILURE";

export const PETTY_CASH_GET_REQUEST = "PETTY_CASH_GET_REQUEST";
export const PETTY_CASH_GET_SUCCESS = "PETTY_CASH_GET_SUCCESS";
export const PETTY_CASH_GET_FAILURE = "PETTY_CASH_GET_FAILURE";
export const PETTY_CASH_DETAIL_REQUEST = "PETTY_CASH_DETAIL_REQUEST";
export const PETTY_CASH_DETAIL_SUCCESS = "PETTY_CASH_DETAIL_SUCCESS";
export const PETTY_CASH_DETAIL_FAILURE = "PETTY_CASH_DETAIL_FAILURE";
export const PETTY_CASH_DETAIL_CLEAR = "PETTY_CASH_DETAIL_CLEAR";
export const PETTY_CASH_STORE_REQUEST = "PETTY_CASH_STORE_REQUEST";
export const PETTY_CASH_STORE_SUCCESS = "PETTY_CASH_STORE_SUCCESS";
export const PETTY_CASH_STORE_FAILURE = "PETTY_CASH_STORE_FAILURE";
export const PETTY_CASH_UPDATE_REQUEST = "PETTY_CASH_UPDATE_REQUEST";
export const PETTY_CASH_UPDATE_SUCCESS = "PETTY_CASH_UPDATE_SUCCESS";
export const PETTY_CASH_UPDATE_FAILURE = "PETTY_CASH_UPDATE_FAILURE";
export const PETTY_CASH_LIST_REQUEST = "PETTY_CASH_LIST_REQUEST";
export const PETTY_CASH_LIST_SUCCESS = "PETTY_CASH_LIST_SUCCESS";
export const PETTY_CASH_LIST_FAILURE = "PETTY_CASH_LIST_FAILURE";
export const PETTY_CASH_SELECT_ARCHIVE_UPDATE =
  "PETTY_CASH_SELECT_ARCHIVE_UPDATE";
export const PETTY_CASH_SAVE_LAST_INFO =
    "PETTY_CASH_SAVE_LAST_INFO";
export const PETTY_CASH_UPDATE_STATE_REQUEST =
  "PETTY_CASH_UPDATE_STATE_REQUEST";
export const PETTY_CASH_UPDATE_STATE_SUCCESS =
  "PETTY_CASH_UPDATE_STATE_SUCCESS";
export const PETTY_CASH_UPDATE_STATE_FAILURE =
  "PETTY_CASH_UPDATE_STATE_FAILURE";
export const PETTY_CASH_REMOVE_REQUEST = "PETTY_CASH_REMOVE_REQUEST";
export const PETTY_CASH_REMOVE_SUCCESS = "PETTY_CASH_REMOVE_SUCCESS";
export const PETTY_CASH_REMOVE_FAILURE = "PETTY_CASH_REMOVE_FAILURE";

export const GET_DETAIL1_BALANCE_SHEET_REQUEST =
  "GET_DETAIL1_BALANCE_SHEET_REQUEST";
export const GET_DETAIL1_BALANCE_SHEET_SUCCESS =
  "GET_DETAIL1_BALANCE_SHEET_SUCCESS";
export const GET_DETAIL1_BALANCE_SHEET_FAILURE =
  "GET_DETAIL1_BALANCE_SHEET_FAILURE";

export const GET_DETAIL2_BALANCE_SHEET_REQUEST =
  "GET_DETAIL2_BALANCE_SHEET_REQUEST";
export const GET_DETAIL2_BALANCE_SHEET_SUCCESS =
  "GET_DETAIL2_BALANCE_SHEET_SUCCESS";
export const GET_DETAIL2_BALANCE_SHEET_FAILURE =
  "GET_DETAIL2_BALANCE_SHEET_FAILURE";

export const API_REMOVE_BALANCE_SHEET_DETAIL2_REQUEST =
    "API_REMOVE_BALANCE_SHEET_DETAIL2_REQUEST";
export const API_REMOVE_BALANCE_SHEET_DETAIL2_SUCCESS =
    "API_REMOVE_BALANCE_SHEET_DETAIL2_SUCCESS";
export const API_REMOVE_BALANCE_SHEET_DETAIL2_FAILURE =
    "API_REMOVE_BALANCE_SHEET_DETAIL2_FAILURE";

export const GET_FILES_REQUEST = "GET_FILES_REQUEST";
export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const GET_FILES_FAILURE = "GET_FILES_FAILURE";

export const DOWNLOAD_FILE_MODAL_DATA = "DOWNLOAD_FILE_MODAL_DATA";
export const DOWNLOAD_FILE_CLOSE_MODAL = "DOWNLOAD_FILE_CLOSE_MODAL";
export const DOWNLOAD_FILE_REPORT_REQUEST = "DOWNLOAD_FILE_REPORT_REQUEST";
export const DOWNLOAD_FILE_REPORT_SUCCESS = "DOWNLOAD_FILE_REPORT_SUCCESS";
export const DOWNLOAD_FILE_REPORT_FAILURE = "DOWNLOAD_FILE_REPORT_FAILURE";
export const DOWNLOAD_FILE_COUNT_TOAST_TOGGLE =
  "DOWNLOAD_FILE_COUNT_TOAST_TOGGLE";
export const DOWNLOAD_FILE_CHECK_FILES_REQUEST =
  "DOWNLOAD_FILE_CHECK_FILES_REQUEST";
export const DOWNLOAD_FILE_CHECK_FILES_SUCCESS =
  "DOWNLOAD_FILE_CHECK_FILES_SUCCESS";
export const DOWNLOAD_FILE_CHECK_FILES_FAILURE =
  "DOWNLOAD_FILE_CHECK_FILES_FAILURE";
export const DOWNLOAD_FILE_TOASTED = "DOWNLOAD_FILE_TOASTED";

export const FEEDBACK_LIST_REQUEST = "FEEDBACK_LIST_REQUEST";
export const FEEDBACK_LIST_SUCCESS = "FEEDBACK_LIST_SUCCESS";
export const FEEDBACK_LIST_FAILURE = "FEEDBACK_LIST_FAILURE";
export const FEEDBACK_TITLES_REQUEST = "FEEDBACK_TITLES_REQUEST";
export const FEEDBACK_TITLES_SUCCESS = "FEEDBACK_TITLES_SUCCESS";
export const FEEDBACK_TITLES_FAILURE = "FEEDBACK_TITLES_FAILURE";
export const FEEDBACK_SHOW_REQUEST = "FEEDBACK_SHOW_REQUEST";
export const FEEDBACK_SHOW_SUCCESS = "FEEDBACK_SHOW_SUCCESS";
export const FEEDBACK_SHOW_FAILURE = "FEEDBACK_SHOW_FAILURE";
export const FEEDBACK_READ_REQUEST = "FEEDBACK_READ_REQUEST";
export const FEEDBACK_READ_SUCCESS = "FEEDBACK_READ_SUCCESS";
export const FEEDBACK_READ_FAILURE = "FEEDBACK_READ_FAILURE";
export const FEEDBACK_STORE_REQUEST = "FEEDBACK_STORE_REQUEST";
export const FEEDBACK_STORE_SUCCESS = "FEEDBACK_STORE_SUCCESS";
export const FEEDBACK_STORE_FAILURE = "FEEDBACK_STORE_FAILURE";
export const FEEDBACK_SCORE_REQUEST = "FEEDBACK_SCORE_REQUEST";
export const FEEDBACK_SCORE_SUCCESS = "FEEDBACK_SCORE_SUCCESS";
export const FEEDBACK_SCORE_FAILURE = "FEEDBACK_SCORE_FAILURE";
export const FEEDBACK_MODAL_DATA = "FEEDBACK_MODAL_DATA";
export const FEEDBACK_CLOSE_MODAL = "FEEDBACK_CLOSE_MODAL";

export const UPDATE_INFO_REQUEST = "UPDATE_INFO_REQUEST";
export const UPDATE_INFO_SUCCESS = "UPDATE_INFO_SUCCESS";
export const UPDATE_INFO_FAILURE = "UPDATE_INFO_FAILURE";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const CHECK_PHONE_NUMBER_REQUEST = "CHECK_PHONE_NUMBER_REQUEST";
export const CHECK_PHONE_NUMBER_SUCCESS = "CHECK_PHONE_NUMBER_SUCCESS";
export const CHECK_PHONE_NUMBER_FAILURE = "CHECK_PHONE_NUMBER_FAILURE";

export const SEND_SMS_REQUEST = "SEND_SMS_REQUEST";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_FAILURE = "SEND_SMS_FAILURE";

export const INVITE_REQUEST = "INVITE_REQUEST";
export const INVITE_SUCCESS = "INVITE_SUCCESS";
export const INVITE_FAILURE = "INVITE_FAILURE";

export const SHARED_CONTACTS_REQUEST = "SHARED_CONTACTS_REQUEST";
export const SHARED_CONTACTS_SUCCESS = "SHARED_CONTACTS_SUCCESS";
export const SHARED_CONTACTS_FAILURE = "SHARED_CONTACTS_FAILURE";

export const SET_USER_STATE_REQUEST = "SET_USER_STATE_REQUEST";
export const SET_USER_STATE_SUCCESS = "SET_USER_STATE_SUCCESS";
export const SET_USER_STATE_FAILURE = "SET_USER_STATE_FAILURE";

export const PREMIUM_INIT_REQUEST = "PREMIUM_INIT_REQUEST";
export const PREMIUM_INIT_SUCCESS = "PREMIUM_INIT_SUCCESS";
export const PREMIUM_INIT_FAILURE = "PREMIUM_INIT_FAILURE";

export const CASH_FLOW_REQUEST = "CASH_FLOW_REQUEST";
export const CASH_FLOW_SUCCESS = "CASH_FLOW_SUCCESS";
export const CASH_FLOW_FAILURE = "CASH_FLOW_FAILURE";
export const REMOVE_CASH_FLOW_REQUEST = "REMOVE_CASH_FLOW_REQUEST";
export const REMOVE_CASH_FLOW_SUCCESS = "REMOVE_CASH_FLOW_SUCCESS";
export const REMOVE_CASH_FLOW_FAILURE = "REMOVE_CASH_FLOW_FAILURE";

export const PREMIUM_TRANSACTION_LIST_REQUEST = "PREMIUM_TRANSACTION_LIST_REQUEST";
export const PREMIUM_TRANSACTION_LIST_SUCCESS = "PREMIUM_TRANSACTION_LIST_SUCCESS";
export const PREMIUM_TRANSACTION_LIST_FAILURE = "PREMIUM_TRANSACTION_LIST_FAILURE";

export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST = "PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST";
export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS = "PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS";
export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE = "PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE";

export const PREMIUM_CALCULATE_PRICE_REQUEST = "PREMIUM_CALCULATE_PRICE_REQUEST";
export const PREMIUM_CALCULATE_PRICE_SUCCESS = "PREMIUM_CALCULATE_PRICE_SUCCESS";
export const PREMIUM_CALCULATE_PRICE_FAILURE = "PREMIUM_CALCULATE_PRICE_FAILURE";

export const PREMIUM_USE_PROMO_CODE_REQUEST = "PREMIUM_USE_PROMO_CODE_REQUEST";
export const PREMIUM_USE_PROMO_CODE_SUCCESS = "PREMIUM_USE_PROMO_CODE_SUCCESS";
export const PREMIUM_USE_PROMO_CODE_FAILURE = "PREMIUM_USE_PROMO_CODE_FAILURE";

export const PREMIUM_USE_WALLET_REQUEST = "PREMIUM_USE_WALLET_REQUEST";
export const PREMIUM_USE_WALLET_SUCCESS = "PREMIUM_USE_WALLET_SUCCESS";
export const PREMIUM_USE_WALLET_FAILURE = "PREMIUM_USE_WALLET_FAILURE";

export const WARN_OWNER_REQUEST = "WARN_OWNER_REQUEST";

export const PREMIUM_INFO_SAVE_IN_CASH = "PREMIUM_INFO_SAVE_IN_CASH";

export const PREMIUM_PAY_REQUEST = "PREMIUM_PAY_REQUEST";
export const PREMIUM_PAY_SUCCESS = "PREMIUM_PAY_SUCCESS";
export const PREMIUM_PAY_FAILURE = "PREMIUM_PAY_FAILURE";

export const PREMIUM_PROMO_CODE_REQUEST = "PREMIUM_PROMO_CODE_REQUEST";
export const PREMIUM_PROMO_CODE_SUCCESS = "PREMIUM_PROMO_CODE_SUCCESS";
export const PREMIUM_PROMO_CODE_FAILURE = "PREMIUM_PROMO_CODE_FAILURE";

export const INVITATION_MAPSA_REQUEST = "INVITATION_MAPSA_REQUEST";
export const INVITATION_MAPSA_SUCCESS = "INVITATION_MAPSA_SUCCESS";
export const INVITATION_MAPSA_FAILURE = "INVITATION_MAPSA_FAILURE";

export const TRANSACTION_ITEM_REQUEST = "TRANSACTION_ITEM_REQUEST";
export const TRANSACTION_ITEM_SUCCESS = "TRANSACTION_ITEM_SUCCESS";
export const TRANSACTION_ITEM_FAILURE = "TRANSACTION_ITEM_FAILURE";

export const GET_COUNTRY_CODE_REQUEST = "GET_COUNTRY_CODE_REQUEST";
export const GET_COUNTRY_CODE_SUCCESS = "GET_COUNTRY_CODE_SUCCESS";
export const GET_COUNTRY_CODE_FAILURE = "GET_COUNTRY_CODE_FAILURE";

export const GET_CURRENCIES_REQUEST = "GET_CURRENCIES_REQUEST";
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS";
export const GET_CURRENCIES_FAILURE = "GET_CURRENCIES_FAILURE";
